var render, staticRenderFns
import script from "./associated_customer_two.vue?vue&type=script&lang=js"
export * from "./associated_customer_two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf1fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cf1fb6')) {
      api.createRecord('78cf1fb6', component.options)
    } else {
      api.reload('78cf1fb6', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/position_information/associated/associated_customer/associated_customer_two.vue"
export default component.exports